import config from 'app-config'


const isServer = config.webpack === 'build.server'


class LocalStorage {

  get(name, defaultValue, storage) {
    if (isServer) {
      console.error('DON\'T USE localStorage ON SERVER SIDE')
      return defaultValue
    }

    try {
      const value = JSON.parse(storage.getItem(name))

      return value !== null ? value : defaultValue
    }
    catch (err) {
      console.log(name)
      console.error(err)

      return defaultValue
    }
  }

  set(name, value, storage) {
    if (isServer) {
      console.error('DON\'T USE localStorage ON SERVER SIDE')
      return
    }

    try {
      storage.setItem(name, JSON.stringify(value))
    }
    catch (err) {
      console.log(name, value)
      console.error(err)
    }
  }

  remove(name, storage) {
    if (isServer) {
      console.error('DON\'T USE localStorage ON SERVER SIDE')
      return
    }

    try {
      storage.removeItem(name)
    }
    catch (err) {
      console.log(name)
      console.error(err)
    }
  }

  getItem(name, defaultValue) {
    return this.get(name, defaultValue, localStorage)
  }

  setItem(name, value) {
    this.set(name, value, localStorage)
  }

  removeItem(name) {
    this.remove(name, localStorage)
  }

  getSessionItem(name, defaultValue) {
    return this.get(name, defaultValue, sessionStorage)
  }

  setSessionItem(name, value) {
    this.set(name, value, sessionStorage)
  }

  removeSessionItem(name) {
    this.remove(name, sessionStorage)
  }
}


export default new LocalStorage()
